import React, { useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useTable, useGlobalFilter, useFilters } from "react-table";
import format from "date-fns/format";

import Button from "./../../../components/Button";
import PageHeader from "../../../components/PageHeader";
import GlobalFilter from "../../../components/GlobalFilter";
import BlankState from "../../../components/BlankState";

import {
  getCompaniesList,
  sendReminder,
  resetReminderStatus,
} from "./../actions";
import { deleteCompany } from "./../../companyAdd/actions";
import Company from "./../../../assets/images/company.svg";

import "./index.scss";
import { deleteFund } from "../../fundsAdd/actions";

export default ({ setSelectedCompany }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const companies = useSelector((state) => state.companyDashboards);
  console.log("companies: ", companies);
  const data = React.useMemo(() => companies.list, [companies.list]);

  useEffect(() => {
    dispatch(getCompaniesList());
  }, [dispatch]);

  useEffect(() => {
    if (!companies.isSendingReminder && companies.isSendingReminderSuccess) {
      alert("Reminder is sent successfully");
      dispatch(resetReminderStatus());
    } else if (
      !companies.isSendingReminder &&
      companies.isSendingReminderFail
    ) {
      alert("Failed to send reminder");
      dispatch(resetReminderStatus());
    }
  }, [
    companies.isSendingReminder,
    companies.isSendingReminderSuccess,
    companies.isSendingReminderFail,
    dispatch,
  ]);

  const handleRowEdit = (fundId) => (event) => {
    event.preventDefault();

    history.push(`/companies/edit/${fundId}`);
  };

  const handleRowDelete = (fundId) => (event) => {
    event.preventDefault();

    if (window.confirm("Are you sure you wish to delete this fund?")) {
      dispatch(deleteFund(fundId));
    }
  };

  const handleSendEmail = (fundId) => (event) => {
    event.preventDefault();
    let ccPartner = false;

    if (window.confirm("Do you want to cc to company partner?")) {
      ccPartner = true;
    }

    if (window.confirm("Do you want to proceed with sending reminder email?")) {
      dispatch(sendReminder(fundId, ccPartner));
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
        Cell: (props) => (
          <div onClick={() => setSelectedCompany(props.data[props.row.index])}>
            {props.value}
          </div>
        ),
      },
      {
        // Investor Name
        Header: "Owner",
        accessor: "ownerName",
        Cell: ({ value }) => (value ? <>{value}</> : "--"),
      },
      {
        // Partner Name
        Header: "Partner",
        accessor: "partnerEmail",
        Cell: ({ value }) => (value ? <>{value}</> : "--"),
      },
      {
        // Last metric date
        Header: "Last Metric Date",
        accessor: "lastMetricDate",
        Cell: ({ value }) => {
          return value ? (
            <>{format(Date.parse(value), "MMM do, yyyy hh:mm aa")}</>
          ) : (
            "--"
          );
        },
      }
    ],
    // eslint-disable-next-line
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
    },
    useFilters,
    useGlobalFilter
  );

  return (
    <div className="company">
      <PageHeader
        icon={<ion-icon name="business-outline"></ion-icon>}
        title="Portfolio Companies"
        subtitle="All portfolio companies"
      >
        <Link to="/add/company">
          <Button type="button">Add Company</Button>
        </Link>
      </PageHeader>
      {companies && companies.list && companies.list.length ? (
        <div className="company__table">
          <div className="company__table__filter">
            <GlobalFilter
              preGlobalFilteredRows={preGlobalFilteredRows}
              globalFilter={state.globalFilter}
              setGlobalFilter={setGlobalFilter}
            />
          </div>

          <table {...getTableProps()}>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()}>
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <BlankState
          text="No companies available"
          icon={<img src={Company} alt="no comapny" />}
        />
      )}
    </div>
  );
};
